import styled from 'styled-components'

export const LayoutContainer = styled.div`
    text-align: center;
    display: grid;
    grid-template-columns: 255px 1fr;
    grid-template-rows: 1fr;
`

export const MobileLayoutContainer = styled.div`
    display: flex;
    flex-direction: column;
    
`

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`